export default "__VITE_ASSET__2axZvGK7__"